import React, { useEffect, useRef, useState } from 'react';
import thumbnail from './Assets/Images/aerial.png'; // Import the thumbnail image

const AerialView = ({
  address,
  videoId = null,
  orientation = 'landscape', // Supported orientations: 'landscape' or 'portrait'
  format = 'mp4_medium'      // Supported formats: 'image', 'mp4_low', 'mp4_medium', 'mp4_high'
}) => {
  const [src, setSrc] = useState(null);
  const videoRef = useRef(null);
  const imageRef = useRef(null);

  // Use videoId if provided, otherwise fallback to address
  const paramValue = videoId || address;
  const parameterKey = videoId ? 'videoId' : 'address';
  const API_KEY = 'AIzaSyDCXx8Pb3Z9dgJAt2SeCrXNejDNH5Ryw4A'; // Ensure this key is valid

  useEffect(() => {
    const initAerialView = async () => {
      const urlParameter = new URLSearchParams();
      urlParameter.set(parameterKey, paramValue);
      urlParameter.set('key', API_KEY);
      const apiUrl = `https://aerialview.googleapis.com/v1/videos:lookupVideo?${urlParameter.toString()}`;

      try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error(`API responded with status ${response.status}`);

        const videoResult = await response.json();
        console.log('AerialView API response:', videoResult);

        if (videoResult.state === 'PROCESSING') return; // Don't display anything if still processing
        if (videoResult.error || !videoResult.uris) return; // Hide component if no video is found

        const videoSrcs = videoResult.uris[format.toUpperCase()];
        if (!videoSrcs) return;

        setSrc(orientation === 'landscape' ? videoSrcs.landscapeUri : videoSrcs.portraitUri);
      } catch (error) {
        console.error('Error fetching aerial view:', error);
      }
    };

    initAerialView();
  }, [paramValue, parameterKey, format, orientation]);

  // If no video source is available, return nothing (hide component)
  if (!src) return null;

  return (
    <div className="aerial-view-container">
      <h3 className="aerial-view-header">Google Aerial View</h3>
      <video ref={videoRef} src={src} controls poster={thumbnail} />
    </div>
  );
};

export default AerialView;
